import { LockClosedIcon, Square2StackIcon, UsersIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const features = [
	{
		name: 'Active Accounts Usage Report',
		description: 'User counts by month for last 3 months. Facilitators are removed from the active total.',
		icon: UsersIcon,
		href: 'account-users',
	},
	{
		name: 'Product Access Report',
		description: 'A list of the ETW products enabled for each client.',
		icon: LockClosedIcon,
		href: '/',
	},
	{
		name: 'Module Access Report',
		description: 'A list of the ALIGN modules enabled for each client.',
		icon: Square2StackIcon,
		href: '/',
	},
];

export default function Reports() {
	const navigate = useNavigate();

	return (
		<div className="relative bg-white py-16 sm:py-24 lg:py-32">
			<div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
				<p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">ETW Reports</p>
				<div className="mt-12">
					<div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
						{features.map(feature => (
							<div key={feature.name} className="pt-6">
								<div className="flow-root rounded-lg bg-gray-50 px-6 pb-8">
									<div
										onClick={() => {
											navigate(feature.href);
										}}
										className="-mt-6">
										<div>
											<span className="inline-flex items-center justify-center rounded-md bg-indigo-500 p-3 shadow-lg">
												<feature.icon className="h-6 w-6 text-white" aria-hidden="true" />
											</span>
										</div>
										<h3 className="mt-8 text-lg font-medium tracking-tight text-gray-900">
											{feature.name}
										</h3>
										<p className="mt-5 text-base text-gray-500">{feature.description}</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
